<template>
  <div>
    <component :is="template"></component>
  </div>
</template>

<script>
    import {STORE_KEY, LOCAL_SAVE_EXERCISE_CLASS} from './_store/constants'
    import {STORE_KEY as STORE_KEY_QUESTION} from '@/modules/question/preview-question/_store/constants'
    import {STORE_KEY as STORE_KEY_EBOOK} from '@/modules/ebooks/_store/constants'
    import store from './_store'
    import storeQuestion from '@/modules/question/preview-question/_store'
    import storeEbook from '@/modules/ebooks/_store'
    import ExerciseList from './_views/ExerciseList'
    import ExerciseDetail from './_views/ExerciseDetail'
    import ExerciseExam from './_views/ExerciseExam'
    import ExerciseEbook from './_views/ExerciseEbook'
    import ExerciseSubject from './_views/ExerciseSubject'
    import ThematicDetail from './_views/thematic/ThematicDetail'
    import ThematicQuestion from './_views/thematic/ThematicQuestion'
    import OtherDetail from './_views/other/OtherDetail'
    import OtherQuestion from './_views/other/OtherQuestion'
    import ExamDetail from './_views/exam/ExamDetail'
    import ExamQuestion from './_views/exam/ExamQuestion'
    import ExamResult from './_views/exam/ExamResult'
    import ExamList from './_views/exam/ExamList'

    export default {
      name: 'ExerciseModule',
      props: {
        template: String
      },
      components: {
        ExerciseList,
        ExerciseDetail,
        ExerciseExam,
        ExerciseEbook,
        ExerciseSubject,
        ThematicDetail,
        ThematicQuestion,
        OtherDetail,
        OtherQuestion,
        ExamDetail,
        ExamQuestion,
        ExamResult,
        ExamList
      },
      created() {
        if (!(STORE_KEY in this.$store._modules.root._children)) {
          this.$store.registerModule(STORE_KEY, store);
        }

        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
          this.$store.registerModule(STORE_KEY_QUESTION, storeQuestion);
        }

        if (!(STORE_KEY_EBOOK in this.$store._modules.root._children)) {
          this.$store.registerModule(STORE_KEY_EBOOK, storeEbook);
        }
      },
      beforeDestroy() {
        localStorage.removeItem(LOCAL_SAVE_EXERCISE_CLASS);
      }
    };
</script>